<script lang="ts" setup>
import MainLayout from '../components/layouts/MainLayout.vue'
import OrderDetails from '../components/orders/OrderDetails.vue'

const props = defineProps<{ id: string }>()
</script>

<template>
  <MainLayout>
    <OrderDetails :id="props.id" />
  </MainLayout>
</template>
